import Jt808SetParameterdataModal from './jt808-set-parameterdata-modal.vue'
export default Jt808SetParameterdataModal
